import { RadioButton } from "primereact/radiobutton";
import styles from "./styles.module.css"
import { useEffect, useState } from "react";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { departments } from "../../utils/helper/departments";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { Divider } from "primereact/divider";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { requestGetTalentsCatalog } from "../../services/wisdomServices/talentService";
import { MultiSelect } from "primereact/multiselect";
import { requestCreateJob } from "../../services/wisdomServices/jobServices";
import { getProjects } from "../../services/wisdomServices/projectService";

function JobRequest(){
    const [loading, setLoading] = useState(false);
    const [formKey, setFormKey] = useState(0);
    const [projectOption, setProjectOption] = useState("New Project");
    const [project, setProject] = useState("");
    const [projects, setProjects] = useState([]);
    const [loadingProjects, setLoadingProjects] = useState(false);
    const [jobTitle, setJobTitle] = useState("");
    const [jobDescription, setJobDescription] = useState("");
    const [department, setDepartment] = useState("");
    const [location, setLocation] = useState("Remote");
    const [employmentType, setEmploymentType] = useState("Full-time");
    const [offerRate, setOfferRate] = useState("");
    const [overview, setOverview] = useState("");
    const [responsibilities, setResponsibilities] = useState("");
    const [requirements, setRequirements] = useState("");
    const [nonNegotiables, setNonNegotiables] = useState("");
    const [niceToHaves, setNiceToHaves] = useState("");
    const [benefits, setBenefits] = useState("");
    const [isContractSigned, setIsContractSigned] = useState(false);
    const [examsRequired, setExamsRequired] = useState("No");
    const [exams, setExams] = useState([]);
    const [otherExam, setOtherExam] = useState("");
    const [selectedSkills, setSelectedSkills] = useState([]);
    const [selectedLanguages, setSelectedLanguages] = useState([]);
    const [skills, setSkills] = useState([]);
    const [languages, setLanguages] = useState([]);
    const [requiredCandidates, setRequiredCandidates] = useState(1)
    const [submitted, setSubmitted] = useState(false);

    useEffect(() => {
        const loadProjects = async () => {
        try {
            setLoadingProjects(true);

            let pageNumber = 1;
            let hasNextPage = true;
            const loadedProjects = [];

            while (hasNextPage) {
            const response = await getProjects(pageNumber, 100);

            loadedProjects.push(...(response?.data || []));

            hasNextPage = response?.pagination?.hasNextPage === true;
            pageNumber += 1;
            }

            const projectOptions = loadedProjects.map((project) => ({
            label: project.name,
            value: project.id,
            }));

            setProjects(projectOptions);
        } catch (error) {
            console.error("Error loading projects:", error);
            setProjects([]);
        } finally {
            setLoadingProjects(false);
        }
        };

        loadProjects();
    }, []);

    const resetForm = () => {
        setProjectOption("New Project");
        setProject("");
        setJobTitle("");
        setJobDescription("");
        setDepartment("");
        setLocation("Remote");
        setEmploymentType("Full-time");
        setOfferRate("");
        setOverview("");
        setResponsibilities("");
        setRequirements("");
        setNonNegotiables("");
        setNiceToHaves("");
        setBenefits("");
        setIsContractSigned(false);
        setExamsRequired("No");
        setExams([]);
        setOtherExam("");
        setSelectedSkills([]);
        setSelectedLanguages([]);
        setRequiredCandidates(1);
        setSubmitted(false);
        setFormKey((currentKey) => currentKey + 1);
    };

    const handleCreateJobRequest = async(e) => {
        e.preventDefault()

        setSubmitted(true);
        if (
            !project ||
            !department ||
            !selectedSkills?.length ||
            !selectedLanguages?.length ||
            !niceToHaves ||
            !nonNegotiables ||
            !requirements ||
            !responsibilities ||
            !overview ||
            !offerRate ||
            !jobDescription ||
            !benefits ||
            !jobTitle
        ) {
            return;
        }
        try {

            const job = {
                accountProjectType: projectOption,
                projectId: project,
                jobTitle,
                jobDescription,
                department,
                location,
                employmentType,
                offerRate,
                requiredCandidates,
                overview,
                responsibilities,
                requirements,
                nonNegotiables,
                niceToHaves,
                benefits,
                clientContractSigned: isContractSigned,
                status: "NOT_STARTED",
                catalog: {
                    SKILL: selectedSkills,
                    LANGUAGE: selectedLanguages
                }
            };

            if (exams.length > 0) {
                job.assessments = exams.join(",");
            }

            if (otherExam?.trim()) {
                job.assessmentsOther = otherExam;
            }


            setLoading(true)
            await requestCreateJob(job);
            resetForm();
        } catch (error) {
            console.error(error)

        } finally {
            setSubmitted(false)
            setLoading(false)

        }
    }

    const onExamsChange = (e) => {
        let _exams = [...exams];

        if (e.checked)
            _exams.push(e.value);
        else
            _exams.splice(_exams.indexOf(e.value), 1);

        setExams(_exams);
    }

    const loadCatalog = async() => {
        try {
            const skills = await requestGetTalentsCatalog('SKILL')
            setSkills(skills)
            const language = await requestGetTalentsCatalog('LANGUAGE')
            setLanguages(language)
        } catch (error) {
            console.error(error)
        }
    }
    useEffect(() => {
        loadCatalog()
    }, [])

    return(
        <div className={styles.jobRequestPage}>
            <div className={styles.jobRequestFormBox}>
                <div className={styles.jobRequestPageTitle}>
                    <h1>New Job Request</h1>

                    <p className={styles.jobRequestPageText}>
                        Fill out the form below to submit a new hiring request for review.<span className={styles.requiredFieldsNotice}>(*) Indicates required fields</span>
                    </p>

                   
                </div>
                <form key={formKey} noValidate onSubmit={handleCreateJobRequest} className={styles.jobRequestForm}>
                    {/* Group 1 */}
                    <div className={styles.projectDetailsContainer}>
                        <div className={styles.projectDetailsContainerTitles}>
                            <h4>Account / Project Details *</h4>
                        </div>
                        <div>
                            <div className={styles.projectOptions}>
                                <div className={styles.projectRadioButtonsBox}>

                                    <div className={styles.projectRadioGroup}>
                                        <span>Is this a new or current project?</span>

                                        <div className={styles.projectRadioButtonsRow}>
                                            <div className={styles.projectRadioButtons}> 
                                                <RadioButton
                                                    inputId="new-project-option"
                                                    name="projectOption"
                                                    value="New Project"
                                                    onChange={(e) => setProjectOption(e.value)}
                                                    checked={projectOption === "New Project"}
                                                />
                                                <label htmlFor="new-project-option">New Project</label>
                                            </div>
                                            <div className={styles.projectRadioButtons}> 
                                                <RadioButton
                                                    inputId="existing-project-option"
                                                    name="projectOption"
                                                    value="Existing Project"
                                                    onChange={(e) => setProjectOption(e.value)}
                                                    checked={projectOption === "Existing Project"}
                                                />
                                                <label htmlFor="existing-project-option">Existing Project</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className={styles.projectRadioGroup}>
                                        <span className={styles.projectTypeRadioTitle}>Type *</span>

                                        <div className={styles.projectRadioButtonsRow}>
                                            <div className={styles.projectRadioButtons}> 
                                                <RadioButton
                                                    inputId="remote-location-type"
                                                    name="locationType"
                                                    value="Remote"
                                                    onChange={(e) => setLocation(e.value)}
                                                    checked={location === "Remote"}
                                                />
                                                <label htmlFor="remote-location-type">Remote</label>
                                            </div>

                                            <div className={styles.projectRadioButtons}> 
                                                <RadioButton
                                                    inputId="onsite-location-type"
                                                    name="locationType"
                                                    value="On-site"
                                                    onChange={(e) => setLocation(e.value)}
                                                    checked={location === "On-site"}
                                                />
                                                <label htmlFor="onsite-location-type">On-site</label>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div className={styles.accountOrProjectInputBox}>
                                <label className={styles.inputLabels} htmlFor="account-project-input">
                                    For what Account / Project? *
                                </label>
                                <Dropdown
                                    className="w-full"
                                    inputId="account-project-input"
                                    filter
                                    value={project}
                                    options={projects}
                                    optionValue="value"
                                    optionLabel="label"
                                    placeholder="Select project"
                                    onChange={(e) => setProject(e.value)}
                                    loading={loadingProjects}
                                    emptyMessage="No projects found"
                                    invalid={submitted && !project}
                                />
                                {submitted && !project && (
                                    <small className="p-error">
                                        Please select a project.
                                    </small>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Group 2 */}
                    <div className={styles.projectDetailsContainer}>
                        <div className={styles.projectDetailsContainerTitles}>
                            <h4>Job Information *</h4>
                        </div>
                        <div className={styles.jobInformationInputFields}>
                            <div>
                                <label className={styles.inputLabels} htmlFor="job-title-input">Job Title *</label>
                                <InputText 
                                    id="job-title-input" 
                                    value={jobTitle}
                                    placeholder="e.g. Senior React Developer" 
                                    style={{width:"100%", backgroundColor:"#FBFAF9"}} 
                                    onChange={(e) => setJobTitle(e.target.value)}
                                    invalid={submitted && !jobTitle}
                                />
                                {submitted && !jobTitle && (
                                    <small className="p-error">
                                        Please add a job title.
                                    </small>
                                )}
                            </div>

                            <div>
                                <label className={styles.inputLabels} htmlFor="job-description-input">Job Description *</label>
                                <InputTextarea 
                                    id="job-description-input" 
                                    value={jobDescription}
                                    placeholder="Provie a brief description of the role" 
                                    style={{width:"100%", backgroundColor:"#FBFAF9"}}
                                    onChange={(e) => setJobDescription(e.target.value)}
                                    invalid={submitted && !jobDescription}
                                />
                                {submitted && !jobDescription && (
                                    <small className="p-error">
                                        Please add a job description.
                                    </small>
                                )}
                            </div>

                            <div>
                                <label className={styles.inputLabels} htmlFor="candidates-required-input">Candidates Required</label>
                                <InputNumber 
                                    id="candidates-required-input" 
                                    value={requiredCandidates}
                                    min={1}
                                    placeholder="Enter the number os required candidates" 
                                    style={{width:"100%", backgroundColor:"#FBFAF9", height:"48px", borderColor:"#E7E4DF"}}
                                    onValueChange={(e) => setRequiredCandidates(e.value)}
                                />
                            </div>
                            
                            <div className={styles.jobInformationDropdowns}>
                                <div className={styles.jobInformationDropdownsCard}> 
                                    <label className={styles.inputLabels} htmlFor="department-input">Department *</label>
                                    <Dropdown 
                                        className="w-full"
                                        inputId="department-input"
                                        value={department}
                                        options={departments}
                                        optionValue="label"
                                        optionLabel="label"
                                        placeholder="Select department" 
                                        onChange={(e) => setDepartment(e.value)}
                                        invalid={submitted && !department}
                                    />
                                    {submitted && !department && (
                                        <small className="p-error">
                                            Please select a department.
                                        </small>
                                    )}

                                </div>
                            </div>

                            <div className={styles.catalogDropdowns}>
                                <div className={styles.catalogDropdownsCard}> 
                                    <label className={styles.inputLabels} htmlFor="skills-input">Skills *</label>
                                    <MultiSelect  
                                        maxSelectedLabels={3}
                                        className="w-full"
                                        inputId="skills-input" 
                                        value={selectedSkills}
                                        options={skills}
                                        optionValue="id"
                                        optionLabel="value"
                                        placeholder="Select skills"
                                        onChange={(e) => setSelectedSkills(e.value)}
                                        invalid={submitted && (!selectedSkills || selectedSkills.length === 0)}
                                    />
                                     {submitted && (!selectedSkills || selectedSkills.length === 0) && (
                                        <small className="p-error">
                                            Please select at least 1 skill.
                                        </small>
                                    )}
                                </div>

                                <div className={styles.catalogDropdownsCard}> 
                                    <label className={styles.inputLabels} htmlFor="langauges-input">Languages *</label>
                                    <MultiSelect  
                                        maxSelectedLabels={3}
                                        className="w-full"
                                        inputId="langauges-input" 
                                        value={selectedLanguages}
                                        options={languages}
                                        optionValue="id"
                                        optionLabel="value"
                                        placeholder="Select languages"
                                        onChange={(e) => setSelectedLanguages(e.value)}
                                        invalid={submitted && (!selectedLanguages || selectedLanguages.length === 0)}
                                    />
                                     {submitted && (!selectedLanguages || selectedLanguages.length === 0) && (
                                        <small className="p-error">
                                            Please select at least 1 language.
                                        </small>
                                    )}

                                </div>
                            </div>

                            <div className={styles.jobInformationTypeAndRateInputsContainer}>
                                <div className={styles.jobInformationTypeAndRateInputs}>
                                    <div className={styles.jobFormRadioTitles}>
                                        <span>Employment Type *</span>
                                    </div>
                                    <div className={styles.jobInformationTypeAndRateRadioButtonsBox}>
                                        <div className={styles.jobInformationTypeAndRateRadioButtons}>
                                            <RadioButton 
                                                inputId="full-time-employment-type-input"
                                                name="fullTime" 
                                                value="Full-time" 
                                                onChange={(e) => setEmploymentType(e.value)} 
                                                checked={employmentType === "Full-time"}
                                            />
                                            <label htmlFor="full-time-employment-type-input">Full-time</label>
                                        </div>
                                        <div className={styles.jobInformationTypeAndRateRadioButtons}>
                                            <RadioButton  
                                                inputId="part-time-employment-type-input"
                                                name="partTime" 
                                                value="Part-time" 
                                                onChange={(e) => setEmploymentType(e.value)} 
                                                checked={employmentType === "Part-time"}
                                            />
                                            <label htmlFor="part-time-employment-type-input">Part-time</label>
                                        </div>

                                    </div>
                                </div>
                                <div className={styles.jobInformationTypeAndRateInputs}>
                                    <label className={styles.inputLabels} htmlFor="offer-rate-input">Offer Rate *</label>
                                    <InputText 
                                        value={offerRate}
                                        inputId="offer-rate-input"
                                        placeholder="e.g. $45K - $65K"
                                        style={{width:"100%", backgroundColor:"#FBFAF9"}}
                                        onChange={(e) => setOfferRate(e.target.value)}
                                        invalid={submitted && !offerRate}
                                    />
                                    {submitted && !offerRate && (
                                        <small className="p-error">
                                            Please add an offer rate.
                                        </small>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Group 3 */}
                    <div className={styles.projectDetailsContainer}>
                        <div className={styles.projectDetailsContainerTitles}>
                            <h4>Role Details *</h4>
                        </div>
                        <div className={styles.roleDetailsInputFields}>
                            <div>
                                <label className={styles.inputLabels} htmlFor="overview-input">Overview *</label>
                                <InputTextarea 
                                    id="overview-input" 
                                    value={overview}
                                    placeholder="Provide an overview of the role" 
                                    style={{width:"100%", backgroundColor:"#FBFAF9"}}
                                    onChange={(e) => setOverview(e.target.value)}
                                    invalid={submitted && !overview}
                                />
                                {submitted && !overview && (
                                <small className="p-error">
                                    Please add a job overview.
                                </small>
                            )}
                            </div>

                            <div>
                                <label className={styles.inputLabels} htmlFor="responsibilities-input">Responsibilities *</label>
                                <InputTextarea 
                                    id="responsibilities-input" 
                                    placeholder="List key responsibilities" 
                                    value={responsibilities}
                                    style={{width:"100%", backgroundColor:"#FBFAF9"}}
                                    onChange={(e) => setResponsibilities(e.target. value)}
                                    invalid={submitted && !responsibilities}
                                />
                                {submitted && !responsibilities && (
                                <small className="p-error">
                                    Please the the responsibilities.
                                </small>
                            )}
                            </div>
                            
                            <div>
                                <label className={styles.inputLabels} htmlFor="requirements-input">Requirements *</label>
                                <InputTextarea 
                                    id="requirements-input" 
                                    placeholder="List job requirements" 
                                    value={requirements}
                                    style={{width:"100%", backgroundColor:"#FBFAF9"}}
                                    onChange={(e) => setRequirements(e.target.value)}
                                    invalid={submitted && !requirements}
                                />
                                {submitted && !requirements && (
                                    <small className="p-error">
                                        Please add the requirements.
                                    </small>
                                )}
                            </div>

                            <div>
                                <label className={styles.inputLabels} htmlFor="non-negotiables-input">Non-Negotiables (From the Client) *</label>
                                <InputTextarea 
                                    id="non-negotiables-input" 
                                    placeholder="List client non-negotiables" 
                                    value={nonNegotiables}
                                    style={{width:"100%", backgroundColor:"#FBFAF9"}}
                                    onChange={(e) => setNonNegotiables(e.target.value)}
                                    invalid={submitted && !nonNegotiables}
                                />
                                {submitted && !nonNegotiables && (
                                    <small className="p-error">
                                        Please add the non negotiables.
                                    </small>
                                )}
                            </div>

                            <div>
                                <label className={styles.inputLabels} htmlFor="nice-to-haves-input">Nice-To-Haves *</label>
                                <InputTextarea 
                                    id="nice-to-haves-input" 
                                    placeholder="List nice-to-have qualifications" 
                                    value={niceToHaves}
                                    style={{width:"100%", backgroundColor:"#FBFAF9"}}
                                    onChange={(e) => setNiceToHaves(e.target.value)}
                                    invalid={submitted && !niceToHaves}
                                />
                                {submitted && !niceToHaves && (
                                    <small className="p-error">
                                        Please add the nice to haves.
                                    </small>
                                )}
                            </div>
                            
                        </div>
                    </div>

                    {/* Group 4 */}
                    <div className={styles.projectDetailsContainer}>
                        <div className={styles.projectDetailsContainerTitles}>
                            <h4>Benefit & Approval *</h4>
                        </div>
                        <div className={styles.roleDetailsInputFields}>
                            <div>
                                <label className={styles.inputLabels} htmlFor="benefits-input">Benefits *</label>
                                <InputTextarea 
                                    id="benefits-input" 
                                    value={benefits}
                                    placeholder="Describe the benefits package" 
                                    style={{width:"100%", backgroundColor:"#FBFAF9"}}
                                    onChange={(e) => setBenefits(e.target.value)}
                                    invalid={submitted && !benefits}
                                />
                                {submitted && !benefits && (
                                <small className="p-error">
                                    Please add the benefits.
                                </small>
                            )}
                            </div>
                            <Divider className={styles.formDivider} />
                            <div>
                                <div className={styles.jobFormRadioTitles}>
                                    <span>Has the client contract been signed (if a new client) or has client approval been received (if it's a current client)?</span>
                                </div>
                                <div className={styles.isContractSignedInputsBox}>
                                    <div className={styles.isContractSignedRadioButton}>
                                        <RadioButton 
                                            inputId="contract-signed-true-input" 
                                            name="yes" 
                                            value={true}
                                            onChange={(e) => setIsContractSigned(e.value)} 
                                            checked={isContractSigned === true}
                                        />
                                        <label htmlFor="contract-signed-true-input">Yes</label>
                                    </div>
                                    <div className={styles.isContractSignedRadioButton}>
                                        <RadioButton 
                                            inputId="contract-signed-false-input" 
                                            name="no" 
                                            value={false}
                                            onChange={(e) => setIsContractSigned(e.value)} 
                                            checked={isContractSigned === false}
                                        />
                                        <label htmlFor="contract-signed-false-input">No</label>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>

                    {/* Group 5 */}
                    <div className={styles.projectDetailsContainer}>
                        <div className={styles.projectDetailsContainerTitles}>
                            <h4>Exams / Assessments</h4>
                            <span className={styles.jobRequestPageText}>Would you like to include any additional assessments for applicants?</span>
                        </div>
                        <div className={styles.roleDetailsInputFields}>
                            <div className={styles.isContractSignedInputsBox}>
                                <div className={styles.isExamsRequired}>
                                    <RadioButton 
                                        inputId="is-exams-required-true-input" 
                                        name="yes" 
                                        value="Yes" 
                                        onChange={(e) => setExamsRequired(e.value)} 
                                        checked={examsRequired === "Yes"}
                                    />
                                    <label htmlFor="is-exams-required-true-input">Yes</label>
                                </div>
                                <div className={styles.isExamsRequired}>
                                    <RadioButton 
                                        inputId="is-exams-required-false-input" 
                                        name="no" 
                                        value="No" 
                                        onChange={(e) => {
                                            setExamsRequired(e.value);
                                            setExams([]);
                                            setOtherExam("");
                                        }} 
                                        checked={examsRequired === "No"}
                                    />
                                    <label htmlFor="is-exams-required-false-input">No</label>
                                </div>
                            </div>
                            {examsRequired === "Yes" && (
                                <div>
                                    <Divider className={styles.formDivider} />
                                    <div>
                                        <div style={{marginBottom:"8px"}}>
                                            <span>If you wish to include other assessments specific to this role, please specify below.</span>
                                        </div>
                                        <div className={styles.examsOptions}>
                                            <div className={styles.isContractSignedInputsBox}>
                                                <div className="flex flex-wrap justify-content-center gap-3">
                                                    <div className={styles.examsCheckBoxes}>
                                                        <Checkbox inputId="typing-speed-test" name="exam" value="TypingSpeedTest" onChange={onExamsChange} checked={exams.includes('TypingSpeedTest')} />
                                                        <label htmlFor="typing-speed-test" className="ml-2">Typing Speed Test</label>
                                                    </div>
                                                    <div className={styles.examsCheckBoxes}>
                                                        <Checkbox inputId="customer-service-simulation" name="exam" value="CustomerServiceSimulation" onChange={onExamsChange} checked={exams.includes('CustomerServiceSimulation')} />
                                                        <label htmlFor="customer-service-simulation" className="ml-2">Customer Service Simulation</label>
                                                    </div>
                                                    <div className={styles.examsCheckBoxes}>
                                                        <Checkbox inputId="logic-aptitude-test" name="exam" value="LogicAptitudeTest" onChange={onExamsChange} checked={exams.includes('LogicAptitudeTest')} />
                                                        <label htmlFor="logic-aptitude-test" className="ml-2">Logic / Aptitude Test</label>
                                                    </div>
                                                    <div className={styles.examsCheckBoxes}>
                                                        <Checkbox inputId="role-knowledge-test" name="exam" value="RoleKnowledgeTest" onChange={onExamsChange} checked={exams.includes('RoleKnowledgeTest')} />
                                                        <label htmlFor="role-knowledge-test" className="ml-2">Role-Specific Knowledge Test</label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className={styles.isContractSignedInputsBox}>
                                                <div className="flex flex-wrap justify-content-center gap-3">
                                                    <div className={styles.examsCheckBoxes}>
                                                        <Checkbox inputId="technical-skills-assessment" name="exam" value="TechnicalSkillsAssessment" onChange={onExamsChange} checked={exams.includes('TechnicalSkillsAssessment')} />
                                                        <label htmlFor="technical-skills-assessment" className="ml-2">Technical Skills Assessment</label>
                                                    </div>
                                                    <div className={styles.examsCheckBoxes}>
                                                        <Checkbox inputId="comunication-skill-test" name="exam" value="CommunicationSkillsTest" onChange={onExamsChange} checked={exams.includes('CommunicationSkillsTest')} />
                                                        <label htmlFor="comunication-skill-test" className="ml-2">Communication Skills Test (Written/Verbal)</label>
                                                    </div>
                                                    <div className={styles.examsCheckBoxes}>
                                                        <Checkbox inputId="data-entry-accuracy-test" name="exam" value="DataEntryAccuracyTest" onChange={onExamsChange} checked={exams.includes('DataEntryAccuracyTest')} />
                                                        <label htmlFor="data-entry-accuracy-test" className="ml-2">Data Entry Accuracy Test</label>
                                                    </div>
                                                    <div className={styles.examsCheckBoxes}>
                                                        <Checkbox inputId="other" name="exam" value="Other" onChange={onExamsChange} checked={exams.includes('Other')} />
                                                        <label htmlFor="other" className="ml-2">Other</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {exams.includes("Other") && (
                                            <div className={styles.otherExamInput}>
                                                <label htmlFor="other-exam-input" className={styles.inputLabels}>Type in what specific exam do you need the applicant to answer. (You can also paste the link below)</label>
                                                <InputText 
                                                    id="other-exam-input" 
                                                    value={otherExam} 
                                                    onChange={(e) => setOtherExam(e.target.value)}
                                                    placeholder="Describe the assessment or paste a link"
                                                    style={{width:"100%", backgroundColor:"#FBFAF9"}}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                            
                        </div>
                    </div>

                    <div>
                        <Button
                            className={styles.submitJobBtn}
                            type="submit"
                            label="Submit Job Request" 
                            icon="pi pi-send" 
                            severity="info" 
                            disabled={loading}
                        />
                    </div>
                </form>
            </div>
        </div>
    )
}

export default JobRequest;